// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__24gIY","active":"downloadDropdown_active___VYrj"};